// JavaScript to apply specific width, height and gap to the target elements
document.addEventListener('DOMContentLoaded', function() {
  // Function to apply styles directly to the elements
  function applyStylesToElements() {
    // Target elements by XPath converted to CSS selectors
    const container = document.querySelector('#halo-auth-sidebar > div:nth-child(2) > form > div:nth-child(6) > div > div:nth-child(3)');
    const elements = [
      document.querySelector('#halo-auth-sidebar > div:nth-child(2) > form > div:nth-child(6) > div > div:nth-child(3) > div:nth-child(1)'),
      document.querySelector('#halo-auth-sidebar > div:nth-child(2) > form > div:nth-child(6) > div > div:nth-child(3) > div:nth-child(2)'),
      document.querySelector('#halo-auth-sidebar > div:nth-child(2) > form > div:nth-child(6) > div > div:nth-child(3) > div:nth-child(3)')
    ];

    // Apply styles to the container
    if (container) {
      Object.assign(container.style, {
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        // width: '400px',
        height: '48px',
        margin: '0 auto'
      });
    }

    // Apply styles to each element
    elements.forEach(function(el) {
      if (el) {
        Object.assign(el.style, {
          // width: '400px',
          height: '48px',
          // minWidth: '400px',
          minHeight: '48px',
          maxWidth: '400px',
          maxHeight: '48px',
          margin: '0',
          padding: '0',
          boxSizing: 'border-box'
        });
      }
    });
  }

  // Call function immediately
  applyStylesToElements();

  // Also set up a mutation observer to handle dynamic changes
  const observer = new MutationObserver(function(mutations) {
    applyStylesToElements();
  });

  // Start observing the document body for changes
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // For Shopify specifically, check for elements when auth sidebar is shown
  document.addEventListener('click', function(e) {
    if (e.target && (e.target.matches('[data-open-auth-sidebar]') || e.target.closest('[data-open-auth-sidebar]'))) {
      // Wait a bit for sidebar to be fully rendered
      setTimeout(applyStylesToElements, 100);
    }
  });
});
